import { useAuth } from '@dustin-web/microsite-components/src/auth'
import {
  useSiteContext,
  useTranslations,
  useUserSettings,
} from '@dustin-web/microsite-components/src/hooks'
import React, { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import AppContext from 'src/appContext'
import { StandardRegisterProps } from '.'
import { State } from './EmailStep'
import Icon from '@dustin-web/microsite-components/src/icon'
import { GaRegEvent } from 'src/components/gaRegistrationHook/gaRegistrationEventHook'

type Props = {
  state: State
}

const Login = ({ state }: Props) => {
  const { translate } = useTranslations()
  const { returnUrl } = useContext(AppContext)
  const { signIn } = useAuth()
  const { twoLetterISOLanguageName } = useUserSettings()
  const { siteType } = useSiteContext()
  const { watch } = useFormContext<StandardRegisterProps>()
  const { loginRegisterGaEvent } = GaRegEvent()

  const handleOnClick = (
    e: React.MouseEvent<HTMLAnchorElement> | React.KeyboardEvent<HTMLAnchorElement>
  ) => {
    e.preventDefault()
    loginRegisterGaEvent()
    signIn({
      cancellationUrl: window.location.origin,
      provider: 'okta',
      siteType: siteType === 'Business' ? 'business' : 'consumer',
      username: watch('email'),
      returnUrl: returnUrl ?? window.location.origin,
      language: twoLetterISOLanguageName,
    })
  }

  switch (state) {
    case State.emailExists:
      return (
        <div className="d-flex align-items-center">
          <Icon className="i-14 u-pr-4" name="info-attention" />
          <p className="u-mb-0">
            <small>{translate('Register_UsernameAlreadyRegisteredOnSite')}</small>
          </p>
        </div>
      )
    case State.isFederated:
      return (
        <div className="d-flex align-items-center">
          <Icon className="i-14 u-pr-4" name="info-attention" />
          <p className="u-mb-0">
            <small>{translate('Register_UsernameFederatedOnSite')}</small>
          </p>
        </div>
      )
    default:
      return (
        <p className="u-pt-8 u-mb-0 u-fs-14">
            {translate('Register_UserHasAccountQuestion')}{' '}
            <a
              className="u-fw-bold"
              style={{ cursor: 'pointer' }}
              onClick={handleOnClick}
              tabIndex={0}
              role="button"
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleOnClick(e)
                }
              }}>
              {translate('RegisterBuinsess_Login')}
            </a>
        </p>
      )
  }
}

export default Login
